"use strict";

exports.__esModule = true;
exports.TableColumn = void 0;

var React = _interopRequireWildcard(require("react"));

var _Table = require("./Table.styles");

var _utils = require("@manifest-ui/utils");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/table/src/TableColumn.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TableColumn = React.forwardRef((props, ref) => {
  const {
    align,
    children,
    isActive,
    isSortable,
    onClick,
    onMouseEnter,
    onMouseLeave,
    sortDirection = 'asc',
    ...other
  } = props;
  const [isHovered, setIsHovered] = React.useState(false);
  let ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return React.createElement(_Table.StyledTableColumn, _extends({
    "aria-sort": isSortable ? ariaSort : undefined,
    className: "manifestui-table-column",
    "data-sortable": isSortable ? '' : null,
    "data-align": align,
    "data-active": isActive ? '' : null,
    "data-hover": isHovered ? '' : null,
    ref: ref
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 7
    }
  }), !isSortable && children, isSortable && React.createElement(_Table.StyledTableSortButton, {
    className: "manifestui-table-sort",
    "data-align": align,
    onClick: onClick,
    onMouseEnter: (0, _utils.chainCallbacks)(() => setIsHovered(true), onMouseEnter),
    onMouseLeave: (0, _utils.chainCallbacks)(() => setIsHovered(false), onMouseLeave),
    type: "button",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 11
    }
  }, children, React.createElement(_Table.StyledTableSortIcon, {
    className: "manifestui-table-sort__icon",
    "data-sort-direction": sortDirection,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 13
    }
  })));
});
exports.TableColumn = TableColumn;
TableColumn.displayName = 'TableColumn';